/**
 * 扫码加好友 —— 二维码编解码。
 *
 * 兼容两种内容格式：
 *  1. 可分享 Web 链接（IdentityCard 现有格式）：
 *     https://mesh.doup.cn/add?peer=12D3KooW...&did=did:dpb:0x...&name=昵称
 *  2. 紧凑 URI（可扩展群组等场景）：
 *     meshlink://add?p=12D3KooW...&d=...&n=...
 */

const PEER_PREFIX = '12D3KooW';

export interface QrContact {
  peerId: string;
  did?: string;
  name?: string;
}

/** 校验 PeerID 基本合法性：Ed25519 公钥 multihash 的 base58（12D3KooW 前缀；标准长度 52 位，兼容放宽 44–64）。 */
export function isValidPeerId(id: string): boolean {
  if (!id || !id.startsWith(PEER_PREFIX) || id.length < 44 || id.length > 64) return false;
  // base58 字符集（Bitcoin 字母表，剔除 0 O I l）
  return /^[1-9A-HJ-NP-Za-km-z]+$/.test(id.slice(PEER_PREFIX.length));
}

/** 从任意文本解析 MeshLink 加好友二维码；非合法好友码返回 null。 */
export function parseQrContact(text: string): QrContact | null {
  const t = (text ?? '').trim();
  if (!t) return null;
  let u: URL;
  try {
    u = new URL(t);
  } catch {
    return null;
  }
  const params = u.searchParams;
  const peerId = (params.get('p') ?? params.get('peer') ?? '').trim();
  if (!isValidPeerId(peerId)) return null;
  const did = (params.get('d') ?? params.get('did') ?? '').trim();
  const name = (params.get('n') ?? params.get('name') ?? '').trim();
  return { peerId, did: did || undefined, name: name || undefined };
}

/** 生成「我的二维码」可分享链接（与 IdentityCard 格式一致，附加昵称便于扫码预览）。 */
export function encodeQrLink(peerId: string, did: string, name?: string): string {
  const base = typeof window !== 'undefined' ? window.location.origin : 'https://mesh.doup.cn';
  const sp = new URLSearchParams({ peer: peerId, did });
  if (name) sp.set('name', name);
  return `${base}/add?${sp.toString()}`;
}
